export interface multipleApprover {
  approverName: String;
  approverUserId: String;
  email: String;
}

export interface StepsApprove {
  stepNo: number;
  stepName: string;
  approverName: string;
  approverUserId: string;
  email: string;
  datetime: string;
  comment: string;
  status: string;
  role: string;
  isDetectUpdateStep: boolean;
  isMultipleApprover: boolean;
  multipleApprover: multipleApprover[];
}

export interface ApprovalOptionMonthly {
  label: string;
  value: string;
}

export interface ApproveMultipleSourcePayload {
  year: number;
  selectedMonths: string[];
  selectedSourceApproval: string[];
  comment: string;
  action: "approved" | "reject";
  companyId: string;
}

export interface OptionApproval {
  month: string[];
  year: number[];
  approveNo: number[];
}

export interface DataApprove {
  status: string;
  month: string;
  year: number;
  companyId: string;
  approveNo: number;
  steps: StepsApprove[];
  currentStep: number;
}

export interface ApproveBody {
  userId: string;
  approveId: string;
  comment: string;
  stepApprove: number;
  status: string;
  name: string;
  email: string;
  month: string;
  year: number;
}

export enum ReportStatusEnum {
  PROCESSING = "processing",
  REQUEST = "request",
  APPROVER_1 = "approver_1",
  APPROVER_2 = "approver_2",
  APPROVER_3 = "approver_3",
  REJECT = "reject",
}

export enum StatusStepEnum {
  REQUEST = "request_approval",
  APPROVED = "approved",
  REJECT = "reject",
  WAITING_FOR_APPROVE = "waiting_for_approval",
}

export interface ResponseAPI {
  message: string;
}

export interface WidthCol {
  jan: string;
  feb: string;
  mar: string;
  apr: string;
  may: string;
  jun: string;
  jul: string;
  aug: string;
  sep: string;
  oct: string;
  nov: string;
  dec: string;
}

export interface WidthColTank {
  [key: string]: string;
}

export const initWidthCol = {
  jan: "",
  feb: "",
  mar: "",
  apr: "",
  may: "",
  jun: "",
  jul: "",
  aug: "",
  sep: "",
  oct: "",
  nov: "",
  dec: "",
};
